import * as React from 'react';
import AccordionContext from '../Accordion/AccordionContext';
import AccordionHeader from './AccordionHeader';
import AccordionPanel from './AccordionPanel';

export interface AccordionSectionProps {
  id: string;
  title: string;
  disabled?: boolean;
  className?: string;
  description?: React.ReactNode;
  expandedTitle?: string;
  collapsedTitle?: string;
  children: React.ReactNode;
}

function AccordionSection(props: AccordionSectionProps) {
  const { expanded, toggle } = React.useContext(AccordionContext);
  const {
    title,
    id,
    children,
    disabled,
    description,
    expandedTitle,
    collapsedTitle,
  } = props;
  const isOpen = expanded[id];

  return (
    <div className="ui-accordion-section">
      <AccordionHeader
        id={id}
        open={isOpen}
        title={title}
        disabled={disabled}
        expandedTitle={expandedTitle}
        collapsedTitle={collapsedTitle}
        description={description}
        onClick={toggle}
      />
      <AccordionPanel id={id} open={isOpen}>
        {children}
      </AccordionPanel>
    </div>
  );
}

export default AccordionSection;
